const getUpgradeCaPlansDictionary = function (data) {
  const upgradeCaPlansDictionary = {
    trademo_intel_ca_pro: {
      name: "Trademo intel Canada Enterprise",
      key: "trademo_intel_ca_pro",
      planFeatures: [
        "1 Billion+ US and other countries' shipments",
        "6 Million+ Global Buyers & Suppliers",
        "$5 Trillion+ Annual Goods Trade",
        "40+ Data points for each Shipment",
        "5000+ HS Codes with more than 10 years global trade trends",
        "100K+ New shipments being added everyday",
      ],
    },
  };
  return upgradeCaPlansDictionary;
};
exports.getUpgradeCaPlansDictionary = getUpgradeCaPlansDictionary;
